import { profile as base } from './base';
import { profile as HU } from './HU';

export const featureConfigMap = {
    base,
    HU,
};
